import AlertUtil from "@/utils/AlertUtil";

export default class extends AlertUtil {

}
